import { RootState } from "../indexReducers";

export const selectedBadgeId = (state: RootState) =>
  state.badgesReducer.selectedBadgeId;

export const badgesData = (state: RootState) => {
  return {
    badges: state.badgesReducer.badgesData?.items,
    data: state.badgesReducer.badgesData,
  };
};

export const loadBadgesDataStatus = (state: RootState) =>
  state.badgesReducer.loadBadgesDataStatus;

export const createBadgesResponse = (state: RootState) =>
  state.badgesReducer.createBadgesResponse;

export const createBadgesStatus = (state: RootState) =>
  state.badgesReducer.createBadgesStatus;

export const deleteBadgeStatus = (state: RootState) =>
  state.badgesReducer.deleteBadgeStatus;
